import React from "react";
import { Link } from "react-router-dom";

// Local optimised logo — tightly cropped from the 1024×1024 master so the
// brand mark fills the rendered square instead of looking like a tiny dot in a
// big blue field. Source master lives at customer-assets.emergentagent.com.
const LOGO_URL = "/arissai-logo.png";

export const BrandMark = ({ size = 36, withWordmark = true, tagline, to = "/", testid = "brand-mark", invert = false, className = "" }) => {
  const wordTone = invert ? "text-white" : "text-zinc-950";
  const tagTone = invert ? "text-white/60" : "text-zinc-500";
  return (
    <Link to={to} className={`inline-flex items-center gap-3 group ${className}`} data-testid={testid}>
      <img
        src={LOGO_URL}
        alt="ARISSAI"
        style={{ height: size, width: size }}
        className="object-contain shrink-0"
      />
      {withWordmark && (
        <div className="flex flex-col leading-tight">
          <span className={`font-display font-black tracking-tight text-lg ${wordTone}`}>ARISSAI</span>
          {tagline && (
            <span className={`text-[10px] tracking-[0.18em] uppercase font-semibold ${tagTone}`}>{tagline}</span>
          )}
        </div>
      )}
    </Link>
  );
};

export const LogoOnly = ({ size = 36, className = "" }) => (
  <img
    src={LOGO_URL}
    alt="ARISSAI"
    style={{ height: size, width: size }}
    className={`object-contain ${className}`}
  />
);

export default BrandMark;
